module.exports = __webpack_public_path__ + "img/img_huanying_nor@2x.8399ee63.png";